import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { toast } from "sonner";
import { Loader2, Lock } from "lucide-react";
import { api, setToken } from "@/lib/auth";
import { BrandLogo } from "@/components/BrandLogo";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      setToken(data.token);
      toast.success("Welcome back.");
      const next = new URLSearchParams(window.location.search).get("next");
      nav(next || "/admin");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grain bg-[#030303] flex items-center justify-center px-6">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        className="w-full max-w-md"
      >
        <div className="mb-2">
          <BrandLogo size="md" />
        </div>
        <p className="mono text-[10px] uppercase tracking-[0.3em] text-[#737373] mb-12 flex items-center gap-2">
          <Lock size={12} /> JCI Admin Portal
        </p>

        <div className="bg-[#0a0a0a] border border-white/10 rounded-sm p-8 lg:p-10">
          <h1 className="serif text-3xl text-[#f4f0ea] mb-8">Sign in</h1>
          <form onSubmit={submit} data-testid="login-form" className="space-y-8">
            <input data-testid="login-email" type="email" className="field" placeholder="Email address" value={email} onChange={(e) => setEmail(e.target.value)} required />
            <input data-testid="login-password" type="password" className="field" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} required />
            <button
              type="submit"
              data-testid="login-submit"
              disabled={loading}
              className="group w-full inline-flex items-center justify-center gap-3 mono text-xs uppercase tracking-[0.2em] px-8 py-5 bg-[#f4f0ea] text-[#030303] rounded-full hover:bg-[#d4af37] transition-colors duration-400 disabled:opacity-60"
            >
              {loading ? <><Loader2 className="animate-spin" size={16} /> Signing in…</> : <>Enter console <span className="group-hover:translate-x-1 transition-transform duration-400">→</span></>}
            </button>
          </form>
        </div>
        <a href="/" className="mono text-[10px] uppercase tracking-[0.25em] text-[#737373] hover:text-[#d4af37] mt-8 inline-block">← Back to site</a>
      </motion.div>
    </div>
  );
}
